// @flow
import React from 'react';
import { FullscreenTitledModal } from 'modal-components';
import { openModal } from 'modal-core-components';
import SegmentCategoryManagerContainer from './SegmentCategoryManagerContainer';

export default function openSegmentCategoryManagerModal(clientId: string, onClose?: () => void) {
  openModal(closeModal => (
    <FullscreenTitledModal
      title="Manage Tags"
      close={() => {
        if (onClose && typeof onClose === 'function') {
          onClose();
        }
        closeModal();
      }}
    >
      <SegmentCategoryManagerContainer clientId={clientId} />
    </FullscreenTitledModal>
  ));
}
